import create from 'zustand';
export type notificationType = 'success' | 'error' | 'warning' | 'info';

export type notificationSize = 'small' | 'modal';
export type notificationPosition = 'left' | 'right';

export type notificationMessage = {
  message: string | Array<string>;
  type: notificationType;
  size: notificationSize;
  persistent: boolean;
  tid: number | undefined;
  onOk?: () => void;
  position?: notificationPosition;
};

type NotificationState = {
  messages: Array<notificationMessage>;
  setNotification: (
    message: string | Array<string>,
    type: notificationType,
    size: notificationSize,
    persistent?: boolean,
    onOk?: () => void,
    position?: notificationPosition,
  ) => void;
  clearAll: () => void;
};
export const useNotificationStore = create<NotificationState>((set, get) => ({
  messages: [],
  setNotification: (
    message: string | Array<string>,
    type: notificationType,
    size: notificationSize,
    persistent: boolean = false,
    onOk?: () => void,
    position?: notificationPosition,
  ) => {
    const messages = get().messages;
    // remove message after x ms
    const tid: number = persistent
      ? -1
      : (setTimeout(() => {
          const messages = get().messages;
          set(() => ({
            messages: messages.filter((m) => m.message !== message),
          }));
        }, 8000) as any);

    messages.push({ message, type, size, tid, persistent, onOk, position });
    set(() => ({ messages: messages }));
  },
  clearAll: () =>
    set(() => {
      get().messages.forEach((m) => clearTimeout(m.tid));
      return { messages: [] };
    }),
}));
